export default {
  'settings.title': '常规设置',
  'settings.onlinePlatforms': '外卖平台',
  'settings.update.success': '更新成功',
  'setting.Deliverect.title': '设置第3方线上平台',
  'setting.Deliverect.description': `
    <p>
      我们同Deliverect一起合作，提供第3方线上平台的多合一的整合方案。
    </p>
    <p>
      为了能接收第3方线上平台订单，您需要使用下面的<i class="bold">Deliverect</i> Portal对各个平台设置菜单，编辑菜品价格，和管理营业时间。
      不过，您仍要使用Chowbus POS Dashboard来新建菜品。我们系统会向Deliverect同步菜品信息。
    </p>
  `,
  'setting.onlineOrderingWebsite.title': '设置餐厅网站',
  'setting.onlineOrderingWebsite.scheduledOrder.switch.label': '允许顾客下预订单',

  'setting.onlineOrderingWebsite.enableCustomizationLimitProperties': '使用附加选项的限制属性',
  'setting.onlineOrderingWebsite.enableCustomizationLimitProperties.description':
    '开启后附加选项将检验并受限于最多选项数，最大可选数和每项最大可选数。',

  'setting.onlineOrderingWebsite.enableShowDishRatings': '显示菜品评分',
  'setting.onlineOrderingWebsite.enableShowGeneratedCategories': '显示Chowbus置顶分类',
  'setting.onlineOrderingWebsite.enableShowGeneratedCategories.description': '包括新品尝鲜/人气热卖',
  'setting.onlineOrderingWebsite.enableDisplayDishForeignName': '显示菜品中文名',
  'setting.onlineOrderingWebsite.enableDisplaySoldOutDishes': '显示售罄菜品和附加选项',
  'setting.onlineOrderingWebsite.enableSortDishesDynamicallyBySales': '根据销量对分类内的菜品动态排序',

  'setting.deliveryConfig.title': '自配送',
  'setting.deliveryConfig.description': '以下平台自己配送。勾选后，对相关平台的订单，您可以在POS指派自己的司机。',
  'setting.deliveryConfig.assignDriver.switch.label': '当手动完成订单，点击完成时，增加弹窗来assign司机。',

  'setting.shoppingCart.send.sendToKitchen.operation': '支付时先执行送厨操作',
  'setting.shoppingCart.send.sendToKitchen.operation.description':
    '（请根据服务类型进行设置，关闭后，可单独进行支付操作，当订单被付清后系统将自动送厨）',
  'setting.shoppingCart.send.confirm.tips': '确认为 {serviceType} 关闭支付时先执行送厨操作吗？',
  'setting.shoppingCart.send.confirm.description':
    '关闭后，可单独进行支付操作。当订单被付清后系统将自动送厨，当为部分支付时，可返回购物车手动进行送厨。',

  'setting.thirdParty.businessHours': '平台店铺营业时间',
  'setting.thirdParty.holidays': '节假日打烊时间',
  'setting.thirdParty.deliveryPlatforms': '平台店铺状态',
  'setting.thirdParty.updateSuccess': '保存更新成功',
  'setting.thirdParty.rowConflicts': '与第{conflictRows}项设置冲突',
  'setting.thirdParty.unbindChannels': '暂未设置任何平台',
};
